import { type ImageLoaderProps } from 'next/image';

export default function imagesLoaderCDN(imageProps: ImageLoaderProps) {
  const {
    quality,
    src,
    width,
  } = imageProps;

  const q = quality ?? 75;
  const isLocal = src.startsWith('/');
  const isDevelopmentEnv = process.env.NODE_ENV === 'development';

  if (isDevelopmentEnv) return `${src}?w=${width.toString()}&q=${q.toString()}`;

  const u = new URL(isLocal ? `${process.env.NEXT_PUBLIC_IMAGES_CDN_URL}${src}` : src);

  if (!u.searchParams.has('width')) u.searchParams.set('width', String(width));
  if (!u.searchParams.has('quality')) u.searchParams.set('quality', String(q));
  if (!u.searchParams.has('format')) u.searchParams.set('format', 'webply');
  if (!u.searchParams.has('auto')) u.searchParams.set('auto', 'webp');

  return u.toString();
}
